import './style.css';
import { inject } from '@vercel/analytics';
import Application from './Application/Application';
// Initialize Vercel Analytics
inject();
const app = new Application();
